module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.6ac7320f.woff2";